// var swiper = new Swiper(".mySwiper", {
//     slidesPerView: 3,
//     spaceBetween: 30,
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//   });

// var swiper = new Swiper(".mySwiper", {
//     slidesPerView: 3,
//     spaceBetween: 30,
//     loop: true,
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//   });

var swiper = new Swiper(".mySwiper", {
  slidesPerView: 3,
  spaceBetween: 30,
  cssMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
  },
  mousewheel: true,
  keyboard: true,
  breakpoints: {
    0: {
      slidesPerView: 1, // Show 1 slide on mobile
    },
    768: {
      slidesPerView: 2, // Show 2 slides on tablets
    },
    1024: {
      slidesPerView: 3, // Show 3 slides on desktops
    },
  },
});


var swiper2 = new Swiper(".mySecondSwiper", {
  cssMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
  },
  mousewheel: true,
  keyboard: true,
});

var swiper3 = new Swiper(".myThirdSwiper", {
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 3, // For tablets and larger screens
    },
    0: {
      slidesPerView: 2, // Show 2 slides on mobile
    }
  }
});

var swiper5 = new Swiper(".myFifthSwiper", {
  pagination: {
    el: ".swiper-pagination",
  },
  autoplay: {
    delay: 1500, 
    disableOnInteraction: false, // Autoplay will not be disabled after user interactions
  },
});

